import React from 'react';
import './button.css';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

const Button = ({ type, onClick, link, style, children }) => {

    const buttonClasses = classnames(
        (!style || style === 'primary') && "button",
        style === 'secondary' && 'button__secondary'
    )

    if(link) {
        return (
            <Link to={link} className="button__link">
                <button className={buttonClasses}>{children}</button>
            </Link>
        )
    }

    return (
        <div>
            <button className={buttonClasses} type={type} onClick={onClick}>
                {children}
            </button>
        </div>
    );

}

export default Button;